import * as TabsPrimitive from "@radix-ui/react-tabs";
import * as React from "react";

import { cn } from "@/lib/utils";

const Tabs = TabsPrimitive.Root;

function TabsList({
  className,
  variant = "default",
  ...props
}: React.ComponentProps<typeof TabsPrimitive.List> & {
  variant?: "default" | "outline-solid";
}) {
  return (
    <TabsPrimitive.List
      className={cn(
        "inline-flex",
        "items-center",
        "text-slate-dim",
        variant === "default" &&
          "rounded-md p-1 bg-slate-subtle border border-slate-dim",
        className,
      )}
      {...props}
    />
  );
}

function TabsTrigger({
  className,
  variant = "default",
  size = "md",
  ...props
}: React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger> & {
  variant?: "default" | "outline-solid";
  size?: "sm" | "md";
}) {
  return (
    <TabsPrimitive.Trigger
      className={cn(
        "inline-flex",
        "gap-2",
        "items-center",
        "justify-center",
        "whitespace-nowrap",
        "rounded-sm",
        variant === "default" &&
          "data-[state=active]:bg-slate-action data-[state=active]:text-slate-normal data-[state=active]:shadow-xs",
        variant === "default" && (size === "md" ? "px-3 py-1.5" : "px-2 py-1"),
        "relative",
        variant === "outline-solid" &&
          "px-5 py-4 hover:text-slate-normal data-[state=active]:text-slate-normal data-[state=active]:after:content-[''] after:absolute after:bottom-0 after:left-0 after:right-0 after:h-0.5 after:bg-slate-11 dark:after:bg-slatedark-11 hover:after:bg-slate-12 dark:hover:after:bg-slatedark-12 after:opacity-0 data-[state=active]:after:opacity-100 after:transition-opacity",
        size === "sm" ? "text-xs" : "text-sm",
        "font-medium",
        "ring-offset-background",
        "transition-all",
        "focus-visible:outline-hidden",
        "focus-visible:ring-2",
        "",
        "focus-visible:ring-offset-2",
        "disabled:pointer-events-none",
        "disabled:opacity-50",
        className,
      )}
      {...props}
    />
  );
}

function TabsContent({
  className,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.Content>) {
  return (
    <TabsPrimitive.Content
      className={cn(
        "[&:not([data-state='inactive'])]:mt-2",
        "ring-offset-background",
        "focus-visible:outline-hidden",
        "focus-visible:ring-2",
        "",
        "focus-visible:ring-offset-2",
        className,
      )}
      {...props}
    />
  );
}
TabsContent.displayName = TabsPrimitive.Content.displayName;

export { Tabs, TabsList, TabsTrigger, TabsContent };
